'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var HardwareHeadsetMic = function HardwareHeadsetMic(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z' })
  );
};
HardwareHeadsetMic = (0, _pure2.default)(HardwareHeadsetMic);
HardwareHeadsetMic.displayName = 'HardwareHeadsetMic';
HardwareHeadsetMic.muiName = 'SvgIcon';

exports.default = HardwareHeadsetMic;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/hardware/headset-mic.js
// module id = 1448
// module chunks = 0